import React from 'react';
import { Checkbox, Tooltip } from '@robinpowered/ui-kit';
import { useTranslation } from 'react-i18next';
import { CancelOption } from '../types';
import { SHELL_OVERLAY_POPUP_Z_INDEX } from 'constants/zIndex';

export const CancelReservationCancelVisits = ({
  selectedOption,
  reservationInProgress,
  shouldCancelVisits,
  handleCheckboxClick,
  reservationUserId,
  showDelegatedWarning = false,
}: {
  selectedOption: CancelOption;
  reservationInProgress: boolean;
  shouldCancelVisits: boolean;
  handleCheckboxClick: NonNullable<
    React.ComponentProps<typeof Checkbox>['onChange']
  >;
  reservationUserId?: string;
  showDelegatedWarning?: boolean;
}): JSX.Element | null => {
  const { t } = useTranslation('peopleProfileSidebar', {
    keyPrefix: 'bookings.cancelReservationModal',
  });

  if (!reservationUserId) {
    return null;
  }

  const isDisabled = reservationInProgress && selectedOption === 'single';
  const shouldHide = showDelegatedWarning && isDisabled;
  const tooltipTitle = isDisabled ? t('option_disabled') : '';

  if (shouldHide) {
    return null;
  }

  return (
    <Tooltip title={tooltipTitle} zIndex={SHELL_OVERLAY_POPUP_Z_INDEX}>
      <Checkbox
        checked={shouldCancelVisits}
        onChange={handleCheckboxClick}
        disabled={isDisabled}
        data-testid="cancel-visits-checkbox"
      >
        {t('update_to_remote')}
      </Checkbox>
    </Tooltip>
  );
};
